export default {
  searchCommentsStatus: '',
  searchCommentsCourse: '',
  searchCommentsLesson: ''
}



// WEBPACK FOOTER //
// ./src/components/comments/store/state.js